import { Directive, ElementRef, forwardRef, inject } from '@angular/core';
import { type ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import type { OdlSelect } from '@odilo/ui-components';

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: 'odl-select',
  providers: [
    // eslint-disable-next-line @angular-eslint/no-forward-ref
    { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => OdlSelectDirective), multi: true },
  ],
  host: {
    '(odl-input)': 'onChange($event.detail.value)',
    '(odl-blur)': 'onTouched()',
  },
})
export class OdlSelectDirective implements ControlValueAccessor {
  private readonly element = inject<ElementRef<OdlSelect>>(ElementRef);

  // eslint-disable-next-line @typescript-eslint/class-methods-use-this
  protected onChange: (value: string | string[]) => void = () => {
    /* empty */
  };
  // eslint-disable-next-line @typescript-eslint/class-methods-use-this
  protected onTouched: () => void = () => {
    /* empty */
  };

  writeValue(value: string | string[]): void {
    this.element.nativeElement.value = value;
  }
  registerOnChange(fn: (value: string | string[]) => void): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }
  setDisabledState?(isDisabled: boolean): void {
    this.element.nativeElement.disabled = isDisabled;
  }
}
